import { useMemo } from 'react';
import type { Order } from '../../types/ordering.types';
import type { Person } from '../../types/timesheet.types';
import {
  OrderListTable,
  COL_REF, COL_DATE, COL_DESC, COL_CATEGORY, COL_EXP_DELIVERY, COL_TOTAL, COL_STATUS, COL_REQUESTER,
} from './OrderListTable';

interface Props {
  orders: Order[];
  isLoading: boolean;
  onOpenOrder: (order: Order) => void;
  search: string;
  people?: Person[]; // reserved for live LM lookup
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function ApprovalsQueue({ orders, isLoading, onOpenOrder, search, people: _people }: Props) {
  const filtered = useMemo(() => {
    if (!search.trim()) return orders;
    const q = search.trim().toLowerCase();
    return orders.filter(o =>
      o.title.toLowerCase().includes(q) ||
      o.orderRef.toLowerCase().includes(q) ||
      o.requesterName.toLowerCase().includes(q)
    );
  }, [orders, search]);

  const columns = [
    COL_REF(), COL_DATE('orderDate'), COL_DESC(), COL_CATEGORY(),
    COL_EXP_DELIVERY(), COL_TOTAL(), COL_STATUS(), COL_REQUESTER(),
  ];

  return (
    <div className="ord-view-content">
      <div className="info-box blue">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
        <span>
          You have <strong>{orders.length} order{orders.length !== 1 ? 's' : ''}</strong> awaiting your approval.
          Click an order to review line items, attachments, and comments.
        </span>
      </div>

      {isLoading ? (
        <div className="ord-empty"><div className="spinner" /> Loading approvals…</div>
      ) : (
        <OrderListTable
          orders={filtered}
          columns={columns}
          onRowClick={onOpenOrder}
          emptyMessage="No orders awaiting your approval."
        />
      )}
    </div>
  );
}
